<template>
  <section class="popular-post">
    <template v-if="popularPosts.vk.data.length">
      <div class="popular-post-preview" :key="`popular-${popularPosts.vk.data[0].id}`" @click="showFullInfo($event, popularPosts.vk.data[0])">
        <div :class="`tonal-indicator  ${getTonalClass(popularPosts.vk.data[0].trust)}`"></div>
        <post-preview-header :post="popularPosts.vk.data[0]" :date-post="moment(popularPosts.vk.data[0].created_date).format('HH:mm DD.MM.YYYY')" />
        <post-preview-body :post="popularPosts.vk.data[0]"></post-preview-body>
        <post-counters :post="popularPosts.vk.data[0]"/>
      </div>
    </template>
    <template v-if="popularPosts.fb.data.length">
      <div class="popular-post-preview" :key="`popular-${popularPosts.fb.data[0].id}`" @click="showFullInfo($event, popularPosts.fb.data[0])">
        <div :class="`tonal-indicator  ${getTonalClass(popularPosts.fb.data[0].trust)}`"></div>
        <post-preview-header :post="popularPosts.fb.data[0]" :date-post="moment(popularPosts.fb.data[0].created_date).format('HH:mm DD.MM.YYYY')" />
        <post-preview-body :post="popularPosts.fb.data[0]"></post-preview-body>
        <post-counters :post="popularPosts.fb.data[0]"/>
      </div>
    </template>
    <template v-if="popularPosts.tw.data.length">
      <div class="popular-post-preview" :key="`popular-${popularPosts.tw.data[0].id}`" @click="showFullInfo($event, popularPosts.tw.data[0])">
        <div :class="`tonal-indicator  ${getTonalClass(popularPosts.tw.data[0].trust)}`"></div>
        <post-preview-header :post="popularPosts.tw.data[0]" :date-post="moment(popularPosts.tw.data[0].created_date).format('HH:mm DD.MM.YYYY')" />
        <post-preview-body :post="popularPosts.tw.data[0]"></post-preview-body>
        <post-counters :post="popularPosts.tw.data[0]"/>
      </div>
    </template>
    <template v-if="popularPosts.gs.data.length">
      <div class="popular-post-preview" v-for="post in popularPosts.gs.data" :key="`popular-${post.id}`" @click="showFullInfo($event, post)">
        <div :class="`tonal-indicator  ${getTonalClass(post.trust)}`"></div>
        <post-preview-header :post="post" :date-post="moment(post.created_date).format('HH:mm DD.MM.YYYY')" />
        <post-preview-body :post="post"></post-preview-body>
        <post-counters :post="post"/>
      </div>
    </template>
  </section>
</template>

<script>
// components
import PostPreviewHeader from '../postPreview/postPreviewHeader.vue';
import PostPreviewBody from '../postPreview/postPreviewBody.vue';
import PostCounters from '../../postCounters.vue';

// moment
import moment from 'moment';

export default {
  name: 'PopularPosts',
  data() {
    return {
      popularPostData: [],
      socials: {
        vk: false,
        fb: false,
        tw: false,
        gs: false
      },
      populars: [],
      network: ['vk', 'fb', 'tw', 'gs'],
      moment,
    };
  },
  props: {
    popularPosts: {
      type: Object,
    },
  },
  methods: {
    showFullInfo(event, post) {
      const target = event.target;
      this.$root.$emit('togglePostToModal', {target, post});
    },
    // перенести в mixin при рефакторинге
    getTonalClass({ trust }) {
      if (trust === null || trust === 0) {
        return 'tonal-indicator__netural';
      }

      if (trust > 0) {
        return 'tonal-indicator__positive';
      }

      return 'tonal-indicator__negative';
    },
    // перенести в helper при рефакторинге
    sourceIcon(source) {
      if (source === 'vk') return 'icon-vk.svg';
      if (source === 'fb') return 'icon-fb.svg';
      if (source === 'gs') return 'icon-smi.svg';
      if (source === 'tw') return 'icon-tw.svg';
      return 'icon-stab.png';
    },
  },
  components: {
    PostPreviewHeader,
    PostPreviewBody,
    PostCounters
  },
};
</script>

<style scoped>
  .popular-post {
    width: 100%;
    display:flex;
    flex-wrap:wrap;
  }

  .popular-post-preview {
    position: relative;
    width: 32%;
    cursor: pointer;
    padding: 15px;
    margin-bottom: 20px;
    margin-right: 20px;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
    transition-property: box-shadow;
    transition-duration: .5s;
  }

  .popular-post-preview:hover {
    box-shadow: 0 5px 10px rgba(0,0,0,0.20);
  }

  .popular-post-preview .post-preview-body {max-height: 100px;}


  .popular-post-preview:nth-child(3n) {
    margin-right: 0;
  }

  .post__date {
    width: 100%;
    text-align: right;
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .post__source-icon {
    margin-right: .5em;
  }

  .tonal-indicator {
    position: absolute;
    overflow: hidden;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
  }

  .tonal-indicator__netural::before {
    display: block;
    position: absolute;
    top: -20px;
    right: -20px;
    width: 40px;
    height: 40px;
    background-color:  #d8e1e9;
    transform: rotate(-45deg);
    content: '';
  }

  .tonal-indicator__positive::before {
    display: block;
    position: absolute;
    top: -20px;
    right: -20px;
    width: 40px;
    height: 40px;
    background-color: #03bb9a;
    transform: rotate(-45deg);
    content: '';
  }

  .tonal-indicator__negative::after {
    display: block;
    position: absolute;
    top: -20px;
    right: -20px;
    width: 40px;
    height: 40px;
    background-color: #ed002b;
    transform: rotate(-45deg);
    content: '';
  }

  @media (max-width: 1365px) {
    .popular-post {
      justify-content: space-between;
    }
    .popular-post-preview {
      width: 360px;
      margin-right: 10px;
    }

    .popular-post-preview:nth-child(3n) {
      margin-right: 0;
    }

    .popular-post-preview:nth-child(2n) {
      margin-right: 0;
    }
  }

  @media (max-width: 1040px) {
    .popular-post {
      justify-content: space-between;
    }
    .popular-post-preview {
      width: 360px;
      margin-right: 0;
    }

    .popular-post-preview:nth-child(3n) {
      margin-right: 0;
    }

    .popular-post-preview:nth-child(2n) {
      margin-right: 0;
    }
  }

  @media (max-width: 760px) {
    .popular-post-preview {
      width: 100%;
      margin-right: 0;
    }

    .popular-post-preview:nth-child(3n) {
      width: 100%;
      margin-right: 0;
    }

    .popular-post-preview:nth-child(2n) {
      margin-right: 0;
      width: 100%;
    }
  }
</style>
